// PhaseFooter Component

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import IntlMessage from '../../../../common/common/intl/intl_message.jsx'
import currency from '../../../../lib/currency.jsx'

class PhaseFooter extends PureComponent {
  static get propTypes () {
    return {
      total: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      total: 0
    }
  }

  render () {
    const { total } = this.props

    return (
      <div className='phase-footer'>
        <div className='footerlabel'>
          <IntlMessage ident='project.budgetContent.footerLabel' />
        </div>
        <div className='total'>{currency.formatSymbol(total)}</div>
      </div>
    )
  }
}

export default PhaseFooter
